/**
 * Cookiebot runs in blocking mode (data-blockingmode="auto"), which injects a
 * full-viewport fixed backdrop (#CybotCookiebotDialogBodyUnderlay) to intercept
 * clicks until consent is given. On small screens the banner renders as a
 * full-screen dialog over that backdrop; after the visitor accepts or declines,
 * Cookiebot hides the dialog but the backdrop can linger, leaving the whole page
 * unclickable. We force-remove the backdrop and clear any scroll lock once the
 * consent choice settles — mirroring how login_error_modal.js removes its own
 * fixed overlay so it can't block interaction.
 */
const COOKIEBOT_UNDERLAY_ID = 'CybotCookiebotDialogBodyUnderlay';

const removeCookiebotBlockingOverlay = () => {
  document.getElementById(COOKIEBOT_UNDERLAY_ID)?.remove();

  // Blocking mode can leave the document scroll-locked on small screens; drop
  // any inline overflow lock so the page scrolls again after dismissal.
  document.documentElement.style.removeProperty('overflow');
  document.body.style.removeProperty('overflow');
};

export const initCookieBannerCleanup = () => {
  addEventListener('CookiebotOnAccept', removeCookiebotBlockingOverlay);
  addEventListener('CookiebotOnDecline', removeCookiebotBlockingOverlay);
};
